import { render, staticRenderFns } from "./groupEditText.vue?vue&type=template&id=0adc6a99"
import script from "./groupEditText.vue?vue&type=script&lang=js"
export * from "./groupEditText.vue?vue&type=script&lang=js"
import style0 from "./groupEditText.vue?vue&type=style&index=0&id=0adc6a99&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports